'use client';

import React, { useState } from 'react';
import { ChevronDown, HelpCircle } from 'lucide-react';
import { FAQItem } from '@/config/tools';

interface FaqAccordionProps {
  faqs: FAQItem[];
}

export function FaqAccordion({ faqs }: FaqAccordionProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const toggle = (idx: number) => {
    setOpenIndex(openIndex === idx ? null : idx);
  };

  return (
    <div className="space-y-3">
      {faqs.map((faq, idx) => {
        const isOpen = openIndex === idx;
        return (
          <div
            key={idx}
            className={`border rounded-xl transition-all overflow-hidden ${
              isOpen ? 'border-slate-300 bg-white shadow-xs' : 'border-slate-200 bg-slate-50/50 hover:bg-slate-50'
            }`}
          >
            <button
              type="button"
              onClick={() => toggle(idx)}
              className="w-full px-5 py-4 text-left flex items-center justify-between gap-4 font-semibold text-slate-900 text-sm sm:text-base focus:outline-none"
            >
              <span className="flex items-center gap-2.5">
                <HelpCircle className={`w-4 h-4 shrink-0 ${isOpen ? 'text-blue-600' : 'text-slate-400'}`} />
                {faq.question || faq.q}
              </span>
              <ChevronDown
                className={`w-4 h-4 text-slate-500 shrink-0 transition-transform duration-200 ${
                  isOpen ? 'rotate-180 text-blue-600' : ''
                }`}
              />
            </button>
            {isOpen && (
              <div className="px-5 pb-4 pt-1 text-sm text-slate-600 border-t border-slate-100 leading-relaxed">
                {faq.answer || faq.a}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
